export const GARLAND_LEFT_IMG =
  'https://cdn.lemanapro.ru/lmru/image/upload/v1743496477/fudzi/navigation-microfronts/apro/season_banner_2025_garland_left.png/season_banner_2025_garland_left.png';

export const CALL_TO_ACTION_IMG =
  'https://cdn.lemanapro.ru/lmru/image/upload/v1744014678/fudzi/navigation-microfronts/apro/season_banner_2025_call_to_action_2.png/season_banner_2025_call_to_action_2.png';

export const BANNER_TEST_ID = 'header-season-banner';
export const BANNER_LINK_TEST_ID = 'header-season-banner-link';
